var _circle, _path, _path2, _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMethods = function SvgMethods(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 94,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 45,
    r: 35,
    fill: "#D1E7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.667 34.333a5.333 5.333 0 0 0-5.333 5.334h29.333a5.333 5.333 0 0 0-5.333-5.334H25.667Z",
    fill: "#0070F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.334 50.333v-8h29.333v8a5.333 5.333 0 0 1-5.333 5.334H25.667a5.333 5.333 0 0 1-5.333-5.334Zm5.333 0h5.334v-2.666h-5.334v2.666Z",
    fill: "#0070F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#methods_svg__a)",
    filter: "url(#methods_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95 80c19.33 0 35-15.67 35-35s-15.67-35-35-35-35 15.67-35 35 15.67 35 35 35Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.155 23.022-.151 20.734 5.89 3.481V33.011l-5.74-9.99Z",
    fill: "#FAB719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.152 48.75v19.978l5.74-10.292v-6.053l-5.74-3.633Z",
    fill: "#61B42C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.998 55.413-36.248-22.4 5.437 9.687 20.54 12.713h10.271Z",
    fill: "#208BC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.152 23.022 20.843 12.713h-10.27l-4.834-2.724-5.739-9.99Z",
    fill: "#F77C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.897 39.004 4.833-3.269H114l-15.103 9.989v-6.72Z",
    fill: "#D60B4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.891 58.432 4.834-3.027h10.27L93.152 68.724l5.74-10.292Z",
    fill: "#097F2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.75 33.014V58.44l5.135-9.383.302-6.357-5.437-9.686Z",
    fill: "#5B59A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.08 45.727-5.195 3.33-5.135 9.383 15.405-9.686-5.074-3.027Z",
    fill: "#9F4393"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#methods_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155 80c19.33 0 35-15.67 35-35s-15.67-35-35-35-35 15.67-35 35 15.67 35 35 35Z",
    fill: "#FFDD2D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#methods_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.365 33.916h-32.73c-6.426 0-11.635 5.224-11.635 11.667s5.209 11.667 11.635 11.667h32.73c6.426 0 11.635-5.224 11.635-11.667s-5.209-11.667-11.635-11.667Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.774 42.127h-4.643v7.437h2.258v-2h2.383c.56 0 1.106-.017 1.637-.188 1.028-.328 1.791-1.25 1.791-2.5s-.748-2.156-1.76-2.514c-.56-.204-1.091-.235-1.668-.235h.002Zm-2.383 3.687v-1.89h2.057c.436 0 .687.048.888.125.359.141.529.468.529.813 0 .374-.203.734-.591.859-.187.062-.405.093-.826.093h-2.057Zm9.049 1.032 1.075-3h.172l1.074 3h-2.321Zm-.56 1.64h3.428l.436 1.078h2.538l-3.038-7.437h-3.303l-3.039 7.437h2.555l.421-1.078h.002Zm11.901-6.359-1.837 3.39h-.079l-1.854-3.39h-2.632l3.349 5.467v1.97h2.337v-2.157l3.18-5.28h-2.464Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.758 39.921h12.548v6.328a4.546 4.546 0 0 1-2.264 3.933l-4.01 2.322-4.01-2.322a4.542 4.542 0 0 1-2.264-3.933v-6.328Z",
    fill: "#FFDD2D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.201 43.252v1.967c.269-.304.756-.51 1.314-.51h.606v2.289c0 .609-.165 1.141-.41 1.435h2.637c-.243-.294-.408-.826-.408-1.434v-2.288h.606c.558 0 1.047.206 1.314.51v-1.967h-5.661l.002-.002Z",
    fill: "#333"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#methods_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215 80c19.33 0 35-15.67 35-35s-15.67-35-35-35-35 15.67-35 35 15.67 35 35 35Z",
    fill: "#13DC20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 80c19.33 0 35-15.67 35-35s-15.67-35-35-35-35 15.67-35 35 15.67 35 35 35Z",
    fill: "url(#methods_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 80c19.33 0 35-15.67 35-35s-15.67-35-35-35-35 15.67-35 35 15.67 35 35 35Z",
    fill: "url(#methods_svg__g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 80c19.33 0 35-15.67 35-35s-15.67-35-35-35-35 15.67-35 35 15.67 35 35 35Z",
    fill: "url(#methods_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 33.3h-28.333C195.223 33.3 190 38.523 190 44.967c0 6.443 5.223 11.666 11.667 11.666H230c6.443 0 11.667-5.223 11.667-11.666 0-6.444-5.224-11.667-11.667-11.667Z",
    fill: "#08B64E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.334 58.333h-26.667A13.335 13.335 0 0 1 188.334 45a13.335 13.335 0 0 1 13.333-13.333h26.667a13.333 13.333 0 1 1 0 26.666Zm-30.13-13.19v-2.105l2.79 1.749 5.8-4.267c.349.45.644.939.88 1.457l-6.68 4.915-2.79-1.75Zm8.426-.304v.152a5.647 5.647 0 0 1-4.28 5.484 5.643 5.643 0 1 1 1.82-10.134l1.431-1.05a7.33 7.33 0 0 0-11.751 4.043 7.33 7.33 0 0 0 3.945 8.26 7.33 7.33 0 0 0 10.53-6.6c0-.44-.04-.88-.118-1.314l-1.577 1.16Zm8.978 4.566v-2.989h1.479c2.81 0 4.317-1.123 4.317-3.356 0-2.166-1.288-3.25-4.317-3.25h-3.193v9.595h1.714Zm0-4.566v-3.452l1.638-.002c1.669 0 2.384.453 2.384 1.632 0 1.302-.823 1.822-2.413 1.822h-1.609Zm6.7-1.808c.451-.338 1.273-.617 2.454-.617 2.001 0 2.988.687 2.988 2.468v4.523h-1.507v-1.234c-.329.794-1.165 1.343-2.263 1.343-1.384 0-2.205-.781-2.205-2.124 0-1.563 1.137-2.002 2.822-2.002h1.549v-.3c0-.973-.465-1.276-1.384-1.276-1.261 0-1.987.494-2.452 1.22l-.002-2.001Zm3.836 3.954v-.554h-1.355c-.947 0-1.399.179-1.399.794 0 .52.383.85 1.096.85 1.082 0 1.59-.617 1.658-1.09Zm4.188-4.434h-1.789l2.885 6.89c-.261.922-.631 1.252-1.123 1.252a1.211 1.211 0 0 1-.823-.344v1.495c.202.177.671.3 1.096.3.905 0 1.521-.37 2.125-2.013l2.74-7.58h-1.699l-1.534 4.7-1.878-4.7Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#methods_svg__i)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 10,
    width: 70,
    height: 70,
    rx: 35,
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.802 45.06-6.876 3.384v-1.908l5.058-2.412-5.058-2.412v-1.854l6.876 3.402v1.8ZM273.82 51V40.902h-2.61v-1.188c1.674-.09 2.754-1.062 3.042-2.214h1.53V51h-1.962Zm10.054.162c-2.988 0-4.95-2.592-4.95-6.948 0-4.32 1.962-6.876 4.95-6.876 2.988 0 4.95 2.556 4.95 6.876 0 4.356-1.962 6.948-4.95 6.948Zm0-12.006c-1.998 0-2.934 2.016-2.934 5.058 0 3.096.936 5.13 2.934 5.13 1.98 0 2.916-2.034 2.916-5.13 0-3.042-.954-5.058-2.916-5.058Z",
    fill: "#0A2540",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "methods_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(60 10)",
    d: "M0 0h70v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "methods_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(120 10)",
    d: "M0 0h70v70H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "methods_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(127 33.916)",
    d: "M0 0h56v23.333H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "methods_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(180 10)",
    d: "M0 0h70v70H0z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "methods_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(135 122.929 56.777) scale(68.3065)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BDFB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BDFB4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "methods_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(135 116.123 59.596) scale(68.059)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19CCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#19CCDC",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19CCDC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "methods_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-45 186.569 -177.28) scale(49.4975)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5ED01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#F5ED01",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5ED01",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "methods_svg__b",
    x: 50,
    y: 4,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_64308_20587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_64308_20587",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "methods_svg__i",
    x: 230,
    y: 4,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_64308_20587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_64308_20587",
    result: "shape"
  })))));
};
export default SvgMethods;